import { ProductPlanDto } from "src/dtos/productPlan/productPlanDto";

export interface PRD1010_R01Dto extends ProductPlanDto {
	
}

export const defaultPRD1010_R01Dto: PRD1010_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productPlanNo: "",
	yearMonth: "",
	compCd: "",
	compNm: "",
	itemCd: "",
	itemNm: "",
	itemSpec: "",
	itemUnit: "",
	planQty: 0,
	orderQty: 0,
	resultQty: 0,
	approveFlg: "N",
	remark: "",

	inserted: false,
	isModified: false,
}